import { NewAPIResponse } from "../../../models/NetworkResponse";
import { getAPI } from "../../../api/Networking";
import { AdminTeam } from "../../../models/AdminTeam/AdminTeam";

export default class AdminTeamsAPI {
  getSubTeams = async (
    parent_team_id: number,
  ): Promise<NewAPIResponse<AdminTeam[]>> => {
    try {
      const response = await getAPI(
        `/v5/admins/teams/team-id/${parent_team_id}/sub-teams`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
